export const gearData = {
  "title": "Recommended Gear",
  "description": "Recommended gear to improve your shooting experience and keep you safe.",
  "categories": [
    {
      "category": "Holsters",
      "items": [
        {
          "name": "CYA Supply Co. Base IWB Concealed Carry Holster",
          "description": "The CYA Supply Co. Base IWB offers exceptional comfort and retention with its precision-molded Kydex construction, perfect for everyday concealed carry.",
          "price_range": "$39",
          "affiliate_link": "https://amzn.to/4qzkYpN"
        },
        {
          "name": "CYA Supply Co. Ridge IWB Holster",
          "description": "The CYA Supply Co. Ridge IWB features enhanced comfort with its sweat guard and adjustable cant, making it ideal for all-day concealed carry.",
          "price_range": "$59",
          "affiliate_link": "https://amzn.to/4hV9vxf"
        },
        {
          "name": "CYA Supply Co. Path IWB Holster",
          "description": "The CYA Supply Co. Path IWB combines premium materials with advanced retention technology, delivering professional-grade security and comfort.",
          "price_range": "$75",
          "affiliate_link": "https://amzn.to/48Wa9Ib"
        }
      ]
    },
    {
      "category": "Ear Protection",
      "items": [
        {
          "name": "Savior Equipment Apollo Electronic Earmuffs",
          "description": "Savior Equipment Apollo Electronic Earmuffs provides superior hearing protection with electronic noise reduction and comfortable fit for extended shooting sessions.",
          "price_range": "$40",
          "affiliate_link": "https://amzn.to/3JxnzQr"
        },
        {
          "name": "Walker's Razor Slim Ultra ",
          "description": "Walker's Razor Slim Ultra provides superior hearing protection with ultra-slim design and advanced sound dampening technology for comfortable range use.",
          "price_range": "$40",
          "affiliate_link": "https://amzn.to/4hBMAqd"
        },
        {
          "name": "Walker's Unisex Adult Razor Quad Muff Bluethooth",
          "description": "Walker's Razor Quad Muff combines four independent microphones with Bluetooth connectivity, delivering premium hearing protection and wireless audio streaming.",
          "price_range": "$60",
          "affiliate_link": "https://amzn.to/47l4Dhe"
        },
        {
          "name": "GLORYFIRE Shooting Ear Protection Earplugs",
          "description": "GLORYFIRE Shooting Ear Protection offers advanced electronic filtering and noise reduction in a compact earplug design, perfect for extended shooting sessions.",
          "price_range": "$160",
          "affiliate_link": "https://amzn.to/49qa4wA"
        }
      ]
    },
    {
      "category": "Eye Protection",
      "items": [
        {
          "name": "xaegistac Shooting Glasses",
          "description": "Xaegistac Shooting Glasses provide affordable ballistic protection with comfortable fit and clear visibility, perfect for recreational shooters.",
          "price_range": "$12",
          "affiliate_link": "https://amzn.to/4hwQi4s"
        },
        {
          "name": "Shooting Glasses",
          "description": "These Shooting Glasses feature crystal-clear optics with anti-fog coating and shatter-resistant polycarbonate lenses for reliable eye protection.",
          "price_range": "$40",
          "affiliate_link": "https://amzn.to/48WVxII"
        },
        {
          "name": "Wiley X Saber Advanced Shooting Glasses",
          "description": "Wiley X Saber Advanced delivers military-spec ballistic protection with wraparound design and interchangeable lenses for optimal vision in any condition.",
          "price_range": "$74",
          "affiliate_link": "https://amzn.to/4oQIv49"
        },
        {
          "name": "Oakley SI Ballistic M Frame 3.0",
          "description": "Oakley SI Ballistic M Frame 3.0 combines legendary Oakley optics with military-grade impact resistance and customizable lens options for professional use.",
          "price_range": "$154",
          "affiliate_link": "https://amzn.to/3WwOO0E"
        }
      ]
    },
    {
      "category": "Targets",
      "items": [
        {
          "name": "Silhouette Paper Target for The Range 50 PCS",
          "description": "These Silhouette Paper Targets offer realistic training scenarios with clear scoring zones and high-contrast printing for accurate shot placement assessment.",
          "price_range": "$20",
          "affiliate_link": "https://amzn.to/4ohyAo8"
        },
        {
          "name": "IPSC/USPSA Practice Paper Shooting Targets 25 PCS",
          "description": "IPSC/USPSA Practice Targets are official competition-sized targets designed for precision training and match preparation with standardized scoring zones.",
          "price_range": "$20",
          "affiliate_link": "https://amzn.to/43J7xtC"
        },
        {
          "name": "3 Inch/4 Inch Splatter Targets, Adhesive Shooting Target Stickers",
          "description": "These Splatter Target Stickers provide instant visual feedback with bright splatter patterns, featuring strong adhesive backing for versatile placement options.",
          "price_range": "$15",
          "affiliate_link": "https://amzn.to/4qIBPH5"
        },
        {
          "name": "Splatter Shooting Targets 6 Inch Reactive Paper Target Stickers",
          "description": "These 6-inch Splatter Targets deliver maximum visibility with reactive technology that creates bright impact halos, perfect for precision shooting practice.",
          "price_range": "$26",
          "affiliate_link": "https://amzn.to/4npMDqt"
        }
      ]
    },
    {
      "category": "Training Tools",
      "items": [
        {
          "name": "9mm Snap Caps – Orange Safety Trainer",
          "description": "These 9mm Snap Caps provide safe dry-fire practice with durable construction and high-visibility orange color for easy identification during training.",
          "price_range": "$13",
          "affiliate_link": "https://amzn.to/4qCzNrE"
        },
        {
          "name": "9mm Luger Precision Snap Cap ",
          "description": "The 9mm Luger Precision Snap Cap offers premium quality construction with precise dimensions for reliable dry-fire training and function testing.",
          "price_range": "$18",
          "affiliate_link": "https://amzn.to/436sUVG"
        },
        {
          "name": "Shot Timer for Shooting Competition",
          "description": "ultra-sensitive shot timer, four-mode design with night-vision display, loud buzzer, and long battery life, built for competition, range training, and serious shooters.",
          "price_range": "$100",
          "affiliate_link": "https://amzn.to/4oDyMhe"
        },
        {
          "name": "PACT Club Timer III - Shot Timer",
          "description": "rugged, reliable, and competition-proven with instant shot detection, bright display, loud buzzer, and simple one-hand controls — trusted by serious shooters and range officers alike.",
          "price_range": "$129",
          "affiliate_link": "https://amzn.to/43CpOZC"
        },
        {
          "name": "SG Timer GO - Shot Timer for Training & Dry Fire",
          "description": "feature-packed, Bluetooth-enabled shot timer with app integration, smart sound detection, 5000-session battery life, quick-release mount.",
          "price_range": "$160",
          "affiliate_link": "https://amzn.to/4nQ1hrz"
        },
        {
          "name": "Dry Fire Magazine",
          "description": "Dry Fire Magazine enables realistic training with magazine-fed laser simulation, providing authentic trigger feel and shot feedback for effective practice.",
          "price_range": "$120",
          "affiliate_link": "https://amzn.to/48PGWP8"
        },
        {
            "name": "Mantis Laser Academy",
            "description": "Mantis Laser Academy transforms dry-fire training with advanced laser technology and smartphone integration for comprehensive shooting skill development.",
            "price_range": "$99",
            "affiliate_link": "https://amzn.to/47NleKy"
        },
        {
          "name": "Mantis X3 Shooting Performance System",
          "description": "Mantis X3 delivers precision shooting analysis with advanced sensors and detailed performance metrics to accelerate marksmanship improvement.",
          "price_range": "$169",
          "affiliate_link": "https://amzn.to/47rWSGl"
        },
        {
            "name": "Mantis X10 Shooting Performance System",
            "description": "Mantis X10 represents the pinnacle of shooting analysis technology with multi-weapon compatibility and professional-grade performance tracking capabilities.",
            "price_range": "$250",
            "affiliate_link": "https://amzn.to/47itVwr"
        }
      ]
    },
    {
      "category": "Range Bags",
      "items": [
        {
          "name": "Savior Specialist Double Pistol Case",
          "description": "rugged 600D PVC design with lockable zippers, padded protection for two handguns and six mags, plus a spacious front pocket for range essentials.",
          "price_range": "$32",
          "affiliate_link": "https://amzn.to/47YEJyX"
        },
        {
          "name": "Orca Gun Range Bag for Shooting – Self Standing with Lockable Zippers",
          "description": "tough, compact, and built to last with 600D polyester, YKK zippers, and lockable storage for 3+ pistols and gear. Backed by a lifetime warranty and made for shooters who demand reliability.",
          "price_range": "$69",
          "affiliate_link": "https://amzn.to/4osdXWI"
        },
        {
          "name": "Savior Specialist 2-Gun Mini Range Bag",
          "description": "compact yet durable 600D PVC design with lockable zippers, padded strap, and organized storage for two pistols, mags, and range essentials.",
          "price_range": "$75",
          "affiliate_link": "https://amzn.to/4nv88WX"
        },
        {
          "name": "Savior Specialist Range Bag",
          "description": "durable 600D PVC construction with lockable zippers, rigid protection, and three padded gun sleeves for secure, organized firearm transport.",
          "price_range": "$112",
          "affiliate_link": "https://amzn.to/4oOjXIW"
        },
        {
          "name": "Savior Specialist SEMA Tactical Pistol Backpack w/ 3 Rug Sleeves",
          "description": "lightweight, durable, and lockable, featuring customizable compartments, three padded gun sleeves, and plenty of space for ammo and range gear.",
          "price_range": "$115",
          "affiliate_link": "https://amzn.to/4hzKR4M"
        },
        {
          "name": "Magpul DAKA Gun Range Bag",
          "description": "rugged, weatherproof, and built to last with 20L of organized storage, durable welded construction, and multiple carry options for effortless range transport.",
          "price_range": "$122",
          "affiliate_link": "https://amzn.to/4nvo63h"
        },
      ]
    },
    {
      "category": "Cleaning Kits",
      "items": [
        {
          "name": "Universal Handgun Cleaning kit",
          "description": "This Universal Handgun Cleaning Kit includes essential tools and solvents for maintaining multiple firearm types with comprehensive cleaning accessories.",
          "price_range": "$16",
          "affiliate_link": "https://amzn.to/4qA3VUH"
        },
        {
          "name": "Clenzoil Pistol Basics Single-Caliber Cleaning Kit - All-in-One",
          "description": "Clenzoil Pistol Basics provides professional-grade cleaning solutions with premium Clenzoil lubricant and precision cleaning tools for optimal firearm maintenance.",
          "price_range": "$25",
          "affiliate_link": "https://amzn.to/4p5ORgf"
        }
      ]
    }
  ]
};